import { render, staticRenderFns } from "./jianyi.vue?vue&type=template&id=327c4dc0&scoped=true&"
import script from "./jianyi.vue?vue&type=script&lang=js&"
export * from "./jianyi.vue?vue&type=script&lang=js&"
import style0 from "./jianyi.vue?vue&type=style&index=0&id=327c4dc0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327c4dc0",
  null
  
)

export default component.exports